import {inject, ref} from "vue";
import ConfirmModal from "@/js/Components/Modal/ConfirmModal.vue";
import ConfirmWithPasswordModal from "@/js/Components/Modal/PasswordConfirmation.vue";
import axios from "axios";

class Action {
    modal;
    router;
    emitter;
    t;
    loader;
    notify;

    constructor(app) {
        this.modal = app.config.globalProperties.$modal;
        this.router = app.config.globalProperties.$router;
        this.t = app.config.globalProperties.$t;
        this.emitter = app.config.globalProperties.$emitter;
        this.loader = app.config.globalProperties.$loader;
        this.notify = app.config.globalProperties.$notifier;
    }

    doAction(action, callback) {
        return new Promise((resolve, reject) => {
            if (action?.confirm) {
                const loading = ref(false);
                let response = null;
                if (action.confirm.password) {
                    response = {
                        config: action.request
                    }
                }
                const properties = Object.assign(action.confirm, {
                    id: action.confirm.password ? 'password-confirmation' : 'confirm',
                    response,
                    loading: loading,
                    onConfirm: (password)=> {
                        loading.value = true;
                        if (password) {
                            action.request.data.password = password;
                        }
                        if (callback) callback(action);

                        this.act(action).then(() => {
                            resolve();
                        }).catch((error) => {
                            const response = error?.response || {};
                            this.notify.error(this.t('global.error_occurred'), response?.data?.message || response?.message);
                            reject(error);
                        }).finally(() => {
                            this.modal('confirm');
                        });
                    }
                });

                try {
                    this.modal(action.confirm?.password ? ConfirmWithPasswordModal : ConfirmModal, properties);
                } catch(e) {
                    console.error(e);
                }
                return;
            }

            if (callback) callback(action);

            this.act(action).then(() => {
                resolve();
            }).catch((error) => {
                reject(error);
            });
        });
    }

    emitActionEvents(action) {
        (action?.events || []).forEach(evt => {
            try {
                this.emitter.emit(evt);
            } catch (error) {
                console.error(error);
            }
        });
    }


    act(action) {
        return new Promise((resolve, reject) => {
            try {
                if (action.redirect) {
                    if (typeof action.redirect === 'string') {
                        if (!action.download && action.target !== '_blank') {
                            this.loader.show();
                        }

                        let url = action.redirect;
                        if (action.data && action.data.length) {
                            url = new URL(url);
                            url.searchParams.set(`${action.key}[]`, action.data);
                            url = url.toString();
                        }

                        window.open(url, action.target);
                    } else {
                        if (action.redirect?.name && action.redirect.name.match('@')) {
                            action.redirect.name = action.redirect.name.replace('@', `${this.router.currentRoute.value.name}.`);
                        }

                        if (action.data && action.data.length) {
                            if (typeof action.redirect.query === 'undefined') {
                                action.redirect.query = {};
                            }
                            action.redirect.query[action.key] = action.data;
                        }

                        this.router.push(action.redirect);
                    }

                    this.emitActionEvents(action);
                    return resolve();
                }

                if (action.request) {
                    const request = { ...action.request };
                    if (action.data && action.data.length) {
                        request.data[action.key] = action.data;
                    }

                    axios(action.request).then((response) => {
                        this.emitActionEvents(action, response);
                        resolve();
                    }).catch(reject);
                    return;
                }
                resolve();
            } catch(e) {
                console.error(e);
            }
        });
    }
}

export default {
    install(app) {
        const action = new Action(app);
        app.provide('action', action.doAction.bind(action));
    }
}

export function useAction() {
    return inject('action');
}